import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TryoutProgram } from '../../interfaces/tryout_interface/tryout-program';
import { InviteTeamList } from '../../interfaces/tryout_interface/invite-team-list';
import { InviteMember } from '../../interfaces/tryout_interface/invite-member';
import { ClubProgramCounters, StorageUtil } from '../../store';
import { HttpService } from '../http.service';


@Injectable()
export class TryoutProgramService {
  private _url = '/api/ClubProgram';
  private _clubUserProgramFee = '/api/ClubUserProgramFee';

  constructor(private http: HttpClient, private httpService: HttpService) { }

  getTryoutProgramsByStatus(status: string | number, typeID: string | number, clubId: string | number, teamId: number = 0): Observable<TryoutProgram[]> {
    // var clubId = '96'; //todo - get it as input parameter
    let url = this._url + '/show-program-by-status-type/' + status + '/' + typeID + '/' + clubId + '?userID=' + StorageUtil.userID;
    if (teamId > 0) {
      url += '&teamID=' + teamId;
    }
    return this.http.get<TryoutProgram[]>(url);
  }

  getTryoutInvitePrograms(clubId: string | number, teamId: number = 0) {
    let url = this._url + '/get-tryout-invite-programs/' + clubId;
    if (teamId > 0) {
      url += '?teamID=' + teamId;
    }
    return this.httpService.get(url);
  }

  getTryoutProgramCounts(typeID: string, clubId: string | number, teamID: number) {
    // const clubId = '96';
    let url = this._url + '/get-billing-count-by-type/' + typeID + '/' + clubId + '?userID=' + StorageUtil.userID;
    if (teamID > 0) {
      url += '&teamID=' + teamID;
    }
    return this.http.get<ClubProgramCounters>(url);
  }
  getTeam(gender: string, ClubProgramID: string): Observable<InviteTeamList[]> {
    return this.http.get<InviteTeamList[]>(this._url + '/get-club-program-team-list/' + gender + '/' + ClubProgramID);
  }

  resendInvite(id: number, pid: number, clubId: number, clubUserProgramFeeID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this._url + `/resend-club-team-invite-link-by-id/${id}/${pid}/${clubId}/${clubUserProgramFeeID}`, httpOptions);
  }

  sendInvite(clubId: number, data: InviteMember) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + `/create-club-team-invite/${clubId}`, data, httpOptions);
  }

  getTryoutRegistrationPlayerInvitationHistoryByID(userID: number, clubProgramId: number) {
    return this.httpService.get(`${this._clubUserProgramFee}/get-tryout-registration-player-invitation-history-by-id/${userID}/${clubProgramId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/tryout_Services/tryout-program.service.ts